var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationCircleFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_89235)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 0.666016C3.95121 0.666016 0.667969 3.94926 0.667969 7.99935C0.667969 12.0494 3.95121 15.3327 8.0013 15.3327C12.0514 15.3327 15.3346 12.0494 15.3346 7.99935C15.3346 3.94926 12.0514 0.666016 8.0013 0.666016ZM8.0013 3.99935C7.63311 3.99935 7.33463 4.29783 7.33463 4.66602C7.33463 5.0342 7.63311 5.33268 8.0013 5.33268H8.00797C8.37616 5.33268 8.67463 5.0342 8.67463 4.66602C8.67463 4.29783 8.37616 3.99935 8.00797 3.99935H8.0013ZM8.66797 7.33268C8.66797 6.96449 8.36949 6.66601 8.0013 6.66601C7.63311 6.66601 7.33463 6.96449 7.33463 7.33268V11.3327C7.33463 11.7009 7.63311 11.9993 8.0013 11.9993C8.36949 11.9993 8.66797 11.7009 8.66797 11.3327V7.33268Z",
    fill: "#CED5DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_89235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleFull);
export default __webpack_public_path__ + "static/media/information-circle-full.675070cbd8663d2898b00c5523add8e5.svg";
export { ForwardRef as ReactComponent };